const { addLogo } = require("./types/add-logo");
const { injectLoadAnim } = require("./types/load-animation");
const { logoRedirect } = require("./types/logo-redirect");
const { panelExpander } = require("./types/panel-expander");
const { offerTableAddOpen } = require("./types/panel-expander-offer");
const { useVinBtn } = require("./types/vin-modal");
const { AddLinkUnderline } = require("./utils/add-link-underline");
const { initFilter } = require("./utils/filter-btn");
const { injectLoadGif } = require("./utils/inject-load-anim");
const { openOffersHandler } = require("./utils/offers-handle");
const { popUpAddClass } = require("./utils/popup-class");
const { removeTitles } = require("./utils/remove-titles");

function handleRakbankMultiEvents() {
    function multiEventFunctions() {
        console.log("multi events triggered");
        initFilter();
        injectLoadAnim();
        logoRedirect();
        addLogo();
        AddLinkUnderline();
        popUpAddClass();
        openOffersHandler();
        removeTitles();
        useVinBtn();
        panelExpander();
        offerTableAddOpen();
        injectLoadGif();
    };

    const events = [
        "DOMContentLoaded",
        "processInitialised.skye",
        "processStepChanged.skye",
        "processUpdated.skye",
        "componentUpdated.skye",
    ];

    events.forEach(function (e) {
        console.log(`${e} is triggered`);
        document.addEventListener(e, multiEventFunctions, false);
    });
};

handleRakbankMultiEvents();